import { Compass, CarFront, MapPin, HeartHandshake, Globe2 } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { DIFERENCIAIS } from "../lib/site";

const icons = { Compass, CarFront, MapPin, HeartHandshake, Globe2 };

export default function Diferenciais() {
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="diferenciais-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-16">
          <SectionTag>Diferenciais</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-brand-deep text-balance">
            Por que viajar <span className="font-serif italic font-medium text-brand-light">com o Magnus?</span>
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {DIFERENCIAIS.map((d, i) => {
            const Icon = icons[d.icon];
            return (
              <Reveal key={d.title} delay={(i % 3) * 0.08}>
                <div className="group" data-testid={`diferencial-${i}`}>
                  <div className="flex items-center gap-4">
                    <span className="grid place-items-center w-12 h-12 rounded-full bg-brand text-white transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                      <Icon size={20} strokeWidth={1.8} />
                    </span>
                    <span className="h-px flex-1 bg-brand/10" />
                  </div>
                  <h3 className="mt-6 font-display font-bold text-lg text-brand-deep">{d.title}</h3>
                  <p className="mt-2 text-moss text-sm md:text-base leading-relaxed">{d.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
